import React, {useState, useEffect,useContext} from 'react'
import { RootStoreContext } from '../../stores/RootStore';
import {StudentAttendanceDetailList, StudentAttendanceDetailParam } from '../../models/Attendance';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { BounceLetterLoader  } from 'react-spinner-overlay'

const StudentAttendanceListDetail = ({rowData}:any) => {

    const rootStore = useContext(RootStoreContext);
    const {getStudentAttendanceListDetail} = rootStore.attendanceStore;

    const [listDetail, setListDetail] = useState<StudentAttendanceDetailList[]>([]) 
    const [isLoading, setIsLoading] = useState(true)

    const param: StudentAttendanceDetailParam = {
        INSTITUTION: String(rowData.INSTITUTION),
        ACAD_CAREER: String(rowData.ACAD_CAREER),
        STRM: String(rowData.STRM),
        EMPLID: String(rowData.EMPLID),
        CREATED_BATCH: String(rowData.CREATED_BATCH),
    };

    console.log(rowData.CREATED_BATCH)

    useEffect(() => {

        getStudentAttendanceListDetail(param).then(function(response) {
            setListDetail(response)
            setIsLoading(false)
        })  
        .catch(() => {

        });
    },[])

    return (
        
        <React.Fragment>
            {isLoading
            ? 
            <div className='detail-loading-container'>
                <BounceLetterLoader letters={'loading course...'} loading={isLoading}　color="#007bff" />
            </div>
            : 
            <>
            <TableContainer sx={{backgroundColor: '#F5F5F5',width: 1/2}}>
                <Table size="small" aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Course Name</TableCell>
                            <TableCell align="right">Class</TableCell>
                            <TableCell align="right">Number of Absences</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listDetail.map((row) => {
                            return <TableRow
                                key={row.CLASS_NBR}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">{row.MATAKULIAH}</TableCell>
                                    <TableCell align="right">{row.CLASS_SECTION}</TableCell>
                                    <TableCell align="right">{row.JUMLAH_ABSEN_DESC}</TableCell>
                                </TableRow>
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            </>
            
            }   
            
        </React.Fragment>
    )

}

export default StudentAttendanceListDetail